module.exports = __webpack_public_path__ + "static/media/025.6a095e7a.jpg";